import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getMessage as getLocalizedMessage } from 'epic-localization/src/client/message/Message';

const mapStateToProps = (state) => {
    return {
        redeemState: state.get('redeem').toJS(),
        messages: state.get('localization').get('messageProperties')
    };
};

@connect(mapStateToProps)
export default class MessageComponent extends React.PureComponent {
    static propTypes = {
        args: PropTypes.array,
        as: PropTypes.node,
        className: PropTypes.string,
        code: PropTypes.string,
        fragment: PropTypes.bool,
        messages: PropTypes.object
    };

    static defaultProps = {
        as: 'span'
    };

    render() {
        const {
            args,
            as: Component,
            className,
            code,
            fragment,
            messages,
            ...otherProps
        } = this.props;

        if (!messages) {
            console.info('localization reducer does not have a message set');
            return (<span />);
        }

        let message = getLocalizedMessage(messages, code, args);
        if (!message) {
            console.warn('message code not found:', code);
            message = (code && code.startsWith('errors.')) ? getLocalizedMessage(messages, 'erros.common') : '';
        }

        message = message || code;
        if (fragment) {
            return <Fragment>{message}</Fragment>;
        }

        return (
            <Component className={className} dangerouslySetInnerHTML={{__html: message}} {...otherProps} />
        );
    }
}

const getMessage = (messages, code, args) => {
    let message = getLocalizedMessage(messages, code, args);
    if (!message) {
        message = (code && code.startsWith('errors.')) ? getLocalizedMessage(messages, 'errors.enterprise.common') : '';
    }
    return message;
};

export {
    getMessage,
    mapStateToProps
};
